import { render, staticRenderFns } from "./KpiBlock.vue?vue&type=template&id=5b743e85&"
import script from "./KpiBlock.vue?vue&type=script&lang=js&"
export * from "./KpiBlock.vue?vue&type=script&lang=js&"
import style0 from "./KpiBlock.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports